import { useSiteInfo, useLoggedInUser } from '~/pages/_shared';
import { useLocalization } from '~/framework';
import { Th, SortButton } from '~/ui-components';
import { GetQuizSessionStruct } from '~/monolith-api';
import { Checkbox, Thead, Tr } from '@chakra-ui/react';
import { useQuizSessionsContext } from '../../QuizSessionsContext';

export function TableHeader() {
   const { _js } = useLocalization();
   const { data: siteInfo } = useSiteInfo();
   const { data: user } = useLoggedInUser();
   const { sort, setSort, handleCancelAllQuizSession, cancelAllQuizSessions } =
      useQuizSessionsContext();

   const highlightFor = (name: keyof GetQuizSessionStruct, defaultUnderline = 'gray.200') => ({
      borderBottomColor: sort.by === name ? 'blue.500' : defaultUnderline,
      color: sort.by === name ? 'blue.500' : 'gray.900',
   });

   return (
      <Thead position="sticky" top={0} backgroundColor="gray.50" opacity={1}>
         <Tr pb="2px">
            <Th {...highlightFor('username')}>
               {siteInfo?.['dev-feature-quizzes-v2'] &&
                  user?.permissions.canIBulkCancelQuizSessions && (
                     <Checkbox
                        isChecked={cancelAllQuizSessions}
                        onChange={() => handleCancelAllQuizSession(!cancelAllQuizSessions)}
                        mr="2"
                     />
                  )}
               {_js('QUIZ TAKEN BY')}
               <SortButton name="username" sort={sort} setSort={setSort} />
            </Th>
            <Th {...highlightFor('doc_title')}>
               {_js('DOCUMENT')}
               <SortButton name="doc_title" sort={sort} setSort={setSort} />
            </Th>
            <Th {...highlightFor('quiz_title')}>
               {_js('QUIZ')}
               <SortButton name="quiz_title" sort={sort} setSort={setSort} />
            </Th>
            <Th {...highlightFor('status')}>
               {_js('STATUS')}
               <SortButton name="status" sort={sort} setSort={setSort} />
            </Th>
            <Th {...highlightFor('last_modified')}>
               {_js('DATE TAKEN')}
               <SortButton name="last_modified" sort={sort} setSort={setSort} />
            </Th>
         </Tr>
      </Thead>
   );
}
